import React from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import { LinePlot } from '@mui/x-charts/LineChart';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { ChartsTooltip } from '@mui/x-charts/ChartsTooltip';
import Box from '@mui/material/Box';

// import StormDateDropDown from "../LIDPanel/StormDateDropDown";

// This component produces the graph for outfalls, where we only want to plot outflow
function STLineChart({ x, y, selectedLayer }) {

    const firstTimestamp = new Date(x[0]);
    const xAxisData = x.map(timestamp => ((new Date(timestamp) - firstTimestamp) / 3600000)); // Convert timestamps to hours
    
    const dataset = xAxisData.map((time, index) => ({
        time,
        runoff: y[index],
    }));

    const series = [
        { type: 'line', dataKey: 'runoff', color: '#26a6e0' },
    ];

    return (
        <Box sx={{ width: '100%', height: '500px', displauy: 'flex', alignItems: 'flex-start', overflow: 'hidden', padding: '0px 0px 0px 0px' }}>
        <Box sx={{ marginBottom: '0px', marginLeft: '0px', marginTop: '5px' }}> </Box>
        <Box sx={{ marginBottom: '0px', marginLeft: '0px', marginTop: '0px' }}>
            {/* <StormDateDropDown /> */}
            <ResponsiveChartContainer
            sx={{
                //change axis label and line colors
                "& .MuiChartsAxis-tickContainer .MuiChartsAxis-tickLabel":{
                    fontFamily: "Roboto",
                    },
                "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel":{
                    fill:"#26a6e0"
                },
                "& .MuiChartsAxis-left .MuiChartsAxis-line":{
                    stroke:"#26a6e0",
                    },
                "& .MuiChartsAxis-left .MuiChartsAxis-tick":{
                    stroke:"#26a6e0",
                    },
                "& .MuiChartsAxis-left .MuiChartsAxis-label":{
                    fill:"#26a6e0",
                    },
            }}
            series={series}
            xAxis={[
                {
                scaleType: 'band',
                dataKey: 'time',
                label: 'Time (hours)',
                tickInterval: (value, index) => index % 24 === 0,
                }
            ]}
            yAxis={[
                { id: 'leftAxis', label: selectedLayer === 'subcatchment' ? "Runoff (cfs)" : "Overflow (cfs)" },
            ]}
            dataset={dataset}
            height={245}
            >
            <LinePlot />
            <ChartsXAxis />
            <ChartsYAxis axisId="leftAxis" />
            <ChartsTooltip/>
            </ResponsiveChartContainer>
        </Box>
        </Box>
    );      
}

export default STLineChart;